function NRUserIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8Z"
        fill={color}
      />
      <path
        d="M8.5 14C7.38152 14 6.27118 14.3364 5.41908 14.9856C4.56127 15.6392 4 16.5928 4 17.6667V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V17.6667C6 17.326 6.17623 16.9231 6.63117 16.5765C7.09182 16.2255 7.76197 16 8.5 16H15.5C16.238 16 16.9082 16.2255 17.3688 16.5765C17.8238 16.9231 18 17.326 18 17.6667V19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19V17.6667C20 16.5928 19.4387 15.6392 18.5809 14.9856C17.7288 14.3364 16.6185 14 15.5 14H8.5Z"
        fill={color}
      />
    </svg>
  );
}

export default NRUserIcon;
